import React from 'react';
import { Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { NumericFormat } from 'react-number-format';

function WasteEstimateDisplay({ value, sx = {}, rounded = false }) {
    const theme = useTheme();
    const percentage = value * 100;
    
    // Determine styling based on thresholds
    let variant = 'normal';
    let backgroundColor, color;
    
    if (percentage >= 15) {
        variant = 'heavy';
        backgroundColor = theme.palette.wasteEstimate.high.background;
        color = theme.palette.wasteEstimate.high.text;
    } else if (percentage >= 10) {
        variant = 'heavy';
        backgroundColor = theme.palette.wasteEstimate.medium.background;
        color = theme.palette.wasteEstimate.medium.text;
    } else if (percentage >= 5) {
        variant = 'heavy';
        backgroundColor = theme.palette.wasteEstimate.low.background;
        color = theme.palette.wasteEstimate.low.text;
    }

    const isHighlighted = percentage >= 5;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: rounded ? 'fit-content' : '100%', alignItems: 'center' }}>
            <Typography 
                variant={variant}
                sx={{
                    ...(isHighlighted && {
                        backgroundColor,
                        color,
                        fontSize: '16px',
                        padding: '4px 8px',
                        borderRadius: '8px',
                        display: 'inline-block',
                        minWidth: 'fit-content',
                        maxWidth: '80px'
                    }),
                    ...sx
                }}
            >
                <NumericFormat 
                    value={rounded ? Math.round(percentage) : percentage}
                    displayType={'text'}
                    decimalScale={rounded ? 0 : 2}
                    fixedDecimalScale={true}
                    suffix="%"
                />
            </Typography>
        </Box>
    );
}

export default WasteEstimateDisplay;